module.exports = __webpack_public_path__ + "img/lighthouse.b2e61881.png";